<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden" id="capture">
    <mat-card-content class="mat-mdc-card-content text-center">
        <div class="container">
            <div class="profile-header">
                <img src="{{WorkshopInfo.agentLogo | adjust_image_path}}" alt="{{WorkshopInfo.name}}" *ngIf="WorkshopInfo?.agentLogo">
                <img src="../../../../assets/images/avatar-placeholder.png" alt="{{WorkshopInfo.name}}" *ngIf="!WorkshopInfo?.agentLogo">
                <h1>{{WorkshopInfo.name}}</h1>
            </div>

            <div class="info">
                <h2>{{ 'ContactInformation' | translate }}</h2>
                <p><mat-label class="spanTitle">{{ 'Phone' | translate }}</mat-label> : {{WorkshopInfo.agentPhone}}</p>
                <p><mat-label class="spanTitle">{{ 'Email' | translate }}</mat-label> : {{WorkshopInfo.email}}</p>
                <p><mat-label class="spanTitle">{{ 'Address' | translate }}</mat-label> :
                    {{WorkshopInfo.agentGovernorate}} -
                    {{WorkshopInfo.agentAddress}}
                </p>
            </div>

            <mat-divider></mat-divider>

            <div class="row m-t-24">
                <div class="col-sm-12">
                    <button mat-flat-button color="primary" (click)="Share()" class="orangSavebtn">
                        {{ 'Share' | translate }}
                    </button>

                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
